import { Link } from 'react-router-dom';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

export const PromoteEmptyBoardList = () => {
  const { t } = useStore();
  return (
    <Stack space={4} style={{ height: '100%' }} align="center" justify="center">
      <Text font="yuge">
        <span role="img" aria-label="shocked">
          😯
        </span>
      </Text>
      <Stack space={2} align="center">
        <Text font="heading1">{t('jobboards.emptyboards.heading')}</Text>
        <Text font="regular16">{t('jobboards.emptyboards.text')}</Text>
      </Stack>
      <Link to="/settings/jobboards">
        <Button text={t('jobboards.emptyboards.btn')} />
      </Link>
    </Stack>
  );
};
